import classnames from 'classnames';
import React from 'react';
import EdsPageHeader from '@hedtech/react-design-system/core/es/PageHeader';
import Grid from '../Grid';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    pageHeader: {},
    pageHeaderWhite: {
        color: Tokens.colorBrandNeutral100
    }
});
const PageHeader = (props) => {
    const { classes, id, text, white } = props;
    const classOverrides = {
        pageHeader: classes.pageHeader
    };
    if (white) {
        classOverrides.pageHeader = classnames(classes.pageHeader, classes.pageHeaderWhite);
    }
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true },
            React.createElement(EdsPageHeader, { classes: classOverrides, id: id, text: text }))));
};
export default withStyles(styles)(PageHeader);
